import { ControllerException } from '../../lib/shared/controller-exception';
import { HttpRequest } from '../../lib/shared/http-request';
import { HttpRequestVerbs } from '../../lib/shared/http-request-verbs';
import { Injectable } from '@angular/core';
import { ServiceProxyBase } from '../../lib/services/service-proxy-base';

@Injectable()
export class MedispanService {
  accessToken: string;
  constructor(private serviceProxy: ServiceProxyBase) { }

  // [HttpGet, Route("Drug/Names/{Name}")]
  // public IActionResult Search(string Name)
  search(name: string) {
    const httpRequest = new HttpRequest<{}>();
    httpRequest.token = this.accessToken;
    httpRequest.verb = HttpRequestVerbs.GET;
    httpRequest.uri.host.name = 'Medispan';
    httpRequest.uri.path = `Drug/Names/${name}`;

    return this.serviceProxy.post<{}, {}> (httpRequest);
  }

  // [HttpGet, Route("Drug/{Name}")]
  // public IActionResult Get(string Name)
  getDrug(name: string) {
    const httpRequest = new HttpRequest<{}>();
    httpRequest.token = this.accessToken;
    httpRequest.verb = HttpRequestVerbs.POST;
    httpRequest.uri.host.name = 'Medispan';
    httpRequest.uri.path = `Drug`;
    httpRequest.body = name;

    return this.serviceProxy.post<{}, {}> (httpRequest);
  }

    getDrugByNDC(ndc: string) {
        const httpRequest = new HttpRequest<{}>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.POST;
        httpRequest.uri.host.name = 'Medispan';
        httpRequest.uri.path = `Drug/NDC`;
        httpRequest.body = ndc;

        return this.serviceProxy.post<{}, {}>(httpRequest);
    }

  // [HttpGet, Route("Drug/PackageSize/{NDC}")]
  // public IActionResult GetPackageSize(string NDC)
  getPackageSize(ndc: string) {
    const httpRequest = new HttpRequest<{}>();
    httpRequest.token = this.accessToken;
    httpRequest.verb = HttpRequestVerbs.GET;
    httpRequest.uri.host.name = 'Medispan';
    httpRequest.uri.path = `Drug/PackageSize/${ndc}`;

    return this.serviceProxy.post<{}, {}> (httpRequest);
  }
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/services/medispan/medispan.service.ts